import Backbone from 'backbone';

var Consent = Backbone.Model.extend({
    initialize: function(args) {
        this.consentTypeId = args.consentTypeId;
        //IT supports only ar-AE and ar-SA for arabic language and we have ar-AR which does not work.
        this.locale = args.locale === 'ar-AR' ? 'ar-AE' : args.locale;
    },

    /**
     * @returns {string} The endpoint used to retrieve the consent.
     * Note that the current version uses an apache ProxyPass rule and it might change when added to HA Proxy.
     */
    url: function() {
        return '/consentTextServices/consentText' + '?consentTypeId=' + this.consentTypeId + '&locale=' + this.locale;
    }
});

export default Consent;
